<div class="offcanvas offcanvas-start bg-dark text-white d-md-none" 
     tabindex="-1" 
     id="sidebarOffcanvas"
     aria-labelledby="sidebarOffcanvasLabel">

    <div class="offcanvas-header">
        <h5 class="offcanvas-title" id="sidebarOffcanvasLabel">Navigation</h5>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>

    <div class="offcanvas-body d-flex flex-column flex-shrink-0">
        <ng-container *ngTemplateOutlet="sidebarContent; context: { isMobile: true }"></ng-container>
    </div>
</div>


<!-- Fix Sidebar for Desktop (>= md) -->
<div class="sidebar d-none d-md-flex flex-column flex-shrink-0 col-md-2 col-lg-2 text-white bg-dark">
    <ng-container *ngTemplateOutlet="sidebarContent; context: { isMobile: false }"></ng-container>
</div>


<!-- ------------------------------------------------------------- -->
<!-- TEMPLATE reusable -->
<!-- ------------------------------------------------------------- -->
<ng-template #sidebarContent let-isMobile="isMobile">
    <ul class="nav nav-pills flex-column mb-auto">
        <li class="nav-item">
            <a class="nav-link text-white" 
               aria-current="page" 
               routerLink="" 
               routerLinkActive="active"  
               [routerLinkActiveOptions]="{ exact: true }"
               [attr.data-bs-dismiss]="isMobile ? 'offcanvas' : null">
                <i class="bi-house fs-5"></i>
                {{ 'SIDEBAR.HOME' | translate }}
            </a>
        </li>
        <li>
            <a class="nav-link text-white" 
               routerLink="peoples" 
               routerLinkActive="active" 
               [attr.data-bs-dismiss]="isMobile ? 'offcanvas' : null">
                <i class="bi-person fs-5"></i>
                {{ 'SIDEBAR.PEOPLES' | translate }}
            </a>
        </li>
        <li>
            <a class="nav-link text-white" 
               routerLink="teams" 
               routerLinkActive="active" 
               [attr.data-bs-dismiss]="isMobile ? 'offcanvas' : null">
                <i class="bi-people fs-5"></i>
                {{ 'SIDEBAR.TEAMS' | translate }}
            </a>
        </li>
        <li>
            <a class="nav-link text-white" 
               routerLink="roles" 
               routerLinkActive="active" 
               [attr.data-bs-dismiss]="isMobile ? 'offcanvas' : null">
                <i class="bi-person-badge fs-5"></i>
                {{ 'SIDEBAR.ROLES' | translate }}
            </a>
        </li>
        <li>
            <a class="nav-link text-white" 
               routerLink="skills" 
               routerLinkActive="active" 
               [attr.data-bs-dismiss]="isMobile ? 'offcanvas' : null">
                <i class="bi-boxes fs-5"></i>
                {{ 'SIDEBAR.SKILLS' | translate }}
            </a>
        </li>
    </ul>
    <hr>
    
    @if (currentUser) {
        <div class="dropdown" [class.dropup]="isMobile">
            <a href="#" class="d-flex align-items-center text-white text-decoration-none dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                <p-avatar
                    label="{{ currentUser | initials }}"
                    styleClass="me-2"
                    size="large"
                    shape="circle">
                </p-avatar>
                <strong>{{ currentUser.firstName }} {{ currentUser.lastName }}</strong>
            </a>
            <ul class="dropdown-menu dropdown-menu-dark text-small shadow" aria-labelledby="dropdownUser1">
                <li>
                    <a class="dropdown-item" 
                       routerLink="user/account"
                       [attr.data-bs-dismiss]="isMobile ? 'offcanvas' : null">
                       {{ 'SIDEBAR.ACCOUNT' | translate }}
                    </a>
                </li>
                <li><hr class="dropdown-divider"></li>
                <li>
                    @if (isLogged()) {
                    <a href="#" class="dropdown-item logout-link" (click)="logout()">{{ 'SIDEBAR.LOGOUT' | translate }}</a>
                    }
                </li>
            </ul>
        </div>
    }
</ng-template>
